<script lang="ts">
    
    import { getContext } from "svelte";
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../../Model/State";
    import StateEditable from "../StateEditable.svelte";

    export let store: Writable<any> | Readable<any> | State;
    export let defaultText = 'Sin texto';

    const readonly: Readable<boolean> = getContext('readonly');

</script>

{#if $readonly}
    {$store}
{:else}
    <StateEditable {store} {defaultText} />
{/if}
